import { AxiosResponse } from 'axios';
import { Config } from '../config';
import { LoginResponse } from '../types/authTypes';
import apiClient from './apiClient';

export const loginUser = async (params: {
  email: string;
  password: string;
  loginType: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.login,
    params
  );
  return response;
};

export const signupUser = async (params: {
  name: string;
  email: string;
  password: string;
  loginType: string;
  referralCode: string;
}): Promise<LoginResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.signup,
    params
  );
  return response.data;
};

export const getUserProfile = async (params: {
  email: string;
}): Promise<LoginResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.getUserProfile,
    params
  );
  return response.data;
};

export const updatepassword = async (params: {
  email: string;
  password: string;
  loginType: string;
}): Promise<LoginResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.updatePassword,
    params
  );
  return response.data;
};

export const requestPasswordReset = async (params: {
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post(
    Config.endPoint.resetPasswordRequest,
    params
  );
  return response;
};

export const resetNewPassword = async (params: {
  newPassword: string;
  token: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post(
    Config.endPoint.resetPassword,
    params
  );
  return response;
};
